import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { GridList, GridTile } from '@material-ui/core/GridList';
import GridList from '@material-ui/core/GridList';
import GridTile from '@material-ui/core/GridListTile';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import EditIcon from '@material-ui/core/svg-icons/editor/mode-edit';
// import NotesIcon from '@material-ui/core/svg-icons/action/today';
// import AddIcon from '@material-ui/core/svg-icons/content/add-circle';
import MeetingsAndCollectionsController from './Wizard/MeetingsAndCollectionsController';
import styles from './MeetingsAndCollectionsStyle';
import { getLocalizedName } from '../../../helpers';
// import IconButton from '@material-ui/core/IconButton';
import MeetingNotes from '../../MetadocumentEditor/meetings-notes';
import Loader from '../../Common/Loader';
import StoreController from '@projeccions-pdc/frontend-storage';
import { IconButton } from '@projeccions-pdc/react-icon';
import { withStyles } from '@material-ui/core';
import { isSmartphone, isDeviceOnline } from '../../../helpers';
import LocalizedStrings from '../../Localization/localization';
import AppContext from '../../../AppContext';
import { MeetingsIcon } from '../../Search/Search';

const muiStyles = {
    item: {
        backgroundColor: '#fff',
    }
};

class Meetings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            meetings: undefined,
            loading: true,
            mtgFitlerValue: 'all',
            smartphoneView: undefined,
        };

        this._MeetingsAndCollectionsController = new MeetingsAndCollectionsController(this);
        let appContext = new AppContext();
        let currentUserSub = appContext.getMyInfo().userSub;
        this._StoreController = new StoreController(appContext.getPlatformId(), currentUserSub);
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    }

    async componentDidMount() {
        let appContext = new AppContext();
        appContext.addObserver('mtgComponent', this);
        this.removeListener = isSmartphone((match) => this.handleSizeChange(match));
        await this.refreshMeetings();
        this.refreshOnline();
    }

    componentWillUnmount() {
        this.removeListener();
        let appContext = new AppContext();
        appContext.removeObserver('mtgComponent');
    }

    notifyDataHasChanged = async () => {
        await this.refreshMeetings();
    }

    async componentDidUpdate(prevProps, prevState) {
        // if (prevProps.platformId !== this.props.platformId) {
        //     await this.refreshMeetings();
        // }
    }

    refreshOnline = async () => {
        let isOnline = await isDeviceOnline();
        this.setState({ isOnline });
    }


    async refreshMeetings() {
        try {
            // console.log('refreshMtgs')
            let meetings = this._StoreController.get('mtgs');
            this.setState({ meetings, loading: false });
            meetings = await this._MeetingsAndCollectionsController.getMeetings();
            this.setState({ meetings, loading: false });
            this._StoreController.set('mtgs', meetings);
        } catch (err) {
            console.log('refreshMeetings', err.message);
            if (err.message.indexOf('404') !== -1) {
                let meetings = [];
                this.setState({ meetings, loading: false });
                this._StoreController.set('mtgs', meetings);
            } else {
                this.setState({ loading: false });
            }
        }
    }

    handleOpenModal = () => {
        this.props.openModal('mtg');
    }

    handleMeetingSelected = (evt, meeting, action) => {
        this.props.openContent(meeting.contentId, meeting.objectType, action, evt);
    }

    // handleMeetingEdit = (evt, meeting, action) => {
    //     evt.stopPropagation();
    //     // console.log('handleMeetingEdit', meeting);
    //     this.props.onMeetingSelected(meeting, action, evt);
    // }

    handleMtgFilterChange = (evt) => {
        this.setState({ mtgFitlerValue: evt.target.value });
    }

    renderNotesIcon = (contentId, iconStyle, buttonStyle) => {
        return (
            <MeetingNotes
                isMeetingsOpen={this.state.isMeetingsOpen}
                contentId={contentId}
                openFile={this.props.openFileViewer}
                openContent={this.props.openContent}
                disabled={!this.state.isOnline} >
                <div style={{ padding: '15px' }}>
                    <IconButton
                        name={MeetingsIcon}
                        primaryColor={iconStyle && iconStyle.color ? iconStyle.color : '#fff'}
                        size={'20px'}
                    />
                </div>
            </MeetingNotes>
        );
    }

    getPrimaryLayout = (mtg, date) => {
        let language = new AppContext().getLanguage();
        let month = date.toLocaleString(language, { month: 'long' });
        //let year = date.getFullYear();
        return (
            <div
                onClick={(evt) => this.handleMeetingSelected(evt, mtg, 'show')}
                data-id={mtg.contentId}
                data-type={'mtg'}>
                <div style={styles.featuredMeetingItemDateDay}>{date.getDate()}</div>
                <div style={styles.featuredMeetingItemDateMonth}> {month} </div>
                <div style={styles.featuredMeetingItemTime}>
                    {`${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`}
                </div>
                <div style={styles.featuredMeetingItemTitle} className={this.props.customizationStyle.primaryBackgroundColor}>
                    {getLocalizedName(language, mtg.names)}
                    <div style={styles.editIconStyle}>
                        {this.renderNotesIcon(mtg.contentId)}
                    </div>
                </div>
            </div>
        );
    }

    getSecondaryLayout = (mtg, date) => {
        let iconStyle = {
            // height: '15px',
            // width: '15px'
            color: '#000'
        };
        let buttonStyle = {
            // height: '20px',
            // width: '20px',
            // padding: 0,
            color: '#000'
        };
        let language = new AppContext().getLanguage();
        let month = date.toLocaleString(language, { month: 'long' });


        //let year = date.getFullYear();
        return (
            <GridTile
                data-id={mtg.contentId}
                data-type={'mtg'}
                key={mtg.contentId}
                cols={1}
                rows={1}
                onClick={(evt) => this.handleMeetingSelected(evt, mtg, 'show')}
                style={styles.meetingsItemImageContainer}
                classes={{ tile: this.props.classes.item }}>

                <div style={styles.meetingItemDateMonth}>
                    <div style={styles.bigText} className={this.props.customizationStyle.primaryColor}>{date.getDate()}</div>
                    <div style={styles.dateMonth}> {month} </div>
                </div>
                <div style={styles.meetingItemTime}>
                    {`${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`}
                </div>


                <div style={styles.itemTitleContainer} >
                    {getLocalizedName(language, mtg.names)}
                    <div style={styles.editIconStyle}>
                        {this.renderNotesIcon(mtg.contentId, iconStyle, buttonStyle)}
                    </div>
                </div>

            </GridTile>
        );
    }

    render() {
        //console.log('numMtgs', this.state.meetings.length)
        let header = (
            <div style={styles.titleContainer} >
                <IconButton name='md-add-circle' primaryColor="#fff" size={'20px'} onClick={this.handleOpenModal} />
                {/* <AddIcon onClick={this.handleOpenModal} color='#fff' style={styles.addIcon} /> */}
                {' Meetings'}
                <div style={styles.meetingsFilter} >
                    <Select style={styles.meetingsFilterSelector} value={this.state.mtgFitlerValue} onChange={this.handleMtgFilterChange}>
                        <MenuItem value="all">{LocalizedStrings.mtgFilterAll}</MenuItem>
                        <MenuItem value="priority">{LocalizedStrings.mtgFilterPriority}</MenuItem>
                    </Select>
                </div>
            </div>
        );

        if (this.state.loading) {
            return (
                <div >
                    {header}
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                        <Loader loading={true} size={'30px'} />
                    </div>
                </div >
            );
        } else if (this.state.meetings) {

            let meetings = this.state.meetings.sort((a, b) => {
                return new Date(b.date) - new Date(a.date);
            });
            meetings = meetings.reverse();

            if (this.state.mtgFitlerValue === 'priority') {
                let limit = new Date();
                limit.setHours(0, 0, 0, 0);
                // limit.setDate(limit.getDate() - 1);
                meetings = this.state.meetings.filter((a) => {
                    return limit < new Date(a.date);
                });
            }
            let featured = meetings.length > 0 ? meetings[0] : undefined;
            let FeaturedComponent;
            if (featured) {
                let featuredDate = new Date(featured.date);
                FeaturedComponent = this.getPrimaryLayout(featured, featuredDate);
            } else {
                FeaturedComponent = <div></div>;
            }

            let columns = 3;
            let items = 6;
            if (this.state.smartphoneView === true) {
                columns = 2;
                items = 4;
            }
            if (this.state.mtgFitlerValue === 'all') {
                items = meetings.length - 1;
            }

            let featuredContainerStyle = styles.featuredMeetingContainer;
            if (this.state.smartphoneView === true) {
                featuredContainerStyle = Object.assign({}, styles.featuredMeetingContainer, { width: '100%' });
            }

            return (
                <div>
                    {header}

                    <div style={{ textAlign: 'left', padding: '10px 0px' }}>
                        {featured ?
                            <div style={featuredContainerStyle}>
                                {FeaturedComponent}
                            </div>
                            :
                            ''
                        }
                        {this.state.smartphoneView === true && <br />}
                        {meetings.length > 0 ?
                            <div style={this.state.smartphoneView === true ? styles.meetingsGridListSmartphone : styles.meetingsGridList}>
                                <GridList cols={columns} cellHeight={125} spacing={10} style={styles.gridList}>
                                    {meetings.slice(1, items + 1).map((mtg, index) => {
                                        let date = new Date(mtg.date);
                                        return this.getSecondaryLayout(mtg, date);
                                    })}
                                </GridList>
                            </div>
                            :
                            <div style={styles.noContentPlaceholder} >
                                {LocalizedStrings.noMtgs}
                            </div>
                        }
                    </div>
                </div >
            );
        } else {
            return (
                <div >
                    {header}
                    <div style={{ height: '260px' }} >
                        <div style={styles.noContentPlaceholder} >
                            {LocalizedStrings.noMtgs}
                        </div>
                    </div>
                </div>
            );
        }
    }
}
Meetings.propTypes = {
    openModal: PropTypes.func.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
    customizationStyle: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(muiStyles)(Meetings);